(function($)
{
    //Initialization Code
    $(function()
      {
          $.reject({
                       reject: {
                           all: false,
                           msie5: true, msie6: true, msie7: true, msie8: true
                       },
                       display: ['firefox','chrome','msie','safari','opera'],
                       browserInfo: {
                           firefox: {
                               text: 'Firefox',
                               url: 'http://www.mozilla.com/firefox/'
                           },
                           safari: {
                               text: 'Safari',
                               url: 'http://www.apple.com/safari/download/'
                           },
                           opera: {
                               text: 'Opera',
                               url: 'http://www.opera.com/download/'
                           },
                           chrome: {
                               text: 'Chrome',
                               url: 'http://www.google.com/chrome/'
                           },
                           msie: {
                               text: 'Internet Explorer 9+',
                               url: 'http://www.microsoft.com/windows/Internet-explorer/'
                           }
                       },
                       header: translate('Did you know that your web browser is out of date?'),
                       paragraph1: translate('Your browser is out of date, and may not be compatible with our website.'),
                       paragraph2: translate('To continue using the website we recommend you install one of the popular web browsers found below.'),
                       close: false,
                       closeESC: false,
                       closeCookie: false, // Set cookie to remember close for this session
                       imagePath: staticImageUrl('/browsers/')
                   });
      });

})(jQuery);